module.exports = __webpack_public_path__ + "media/images/official/special_workcation_mochimuneb_01-a859c84b30454e774dca7b2eb91a2aae.jpeg";